<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Neuigkeiten<v-spacer></v-spacer>
        <v-btn
          text
          outlined
          small
          :to="{
            name: 'my-organization-news',
          }"
          >Alle anzeigen</v-btn
        >
      </v-card-title>
      <v-card>
        <v-data-iterator
          :items="news"
          hide-default-footer
          sort-by="publishedAt.timestamp"
          sort-desc
          no-data-text="Keine Neuigkeiten vorhanden."
        >
          <template v-slot:default="props">
            <v-card flat>
              <v-list nav>
                <news-list-items
                  :items="props.items"
                  dense
                  link
                ></news-list-items>
              </v-list>
            </v-card>
          </template>
          <template v-slot:no-data>
            <div
              style="
                height: 200px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <p class="subtitle-1">Keine Neuigkeiten vorhanden.</p>
            </div>
          </template>
        </v-data-iterator>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import NewsListItems from "@/components/my-organization/news/NewsListItems.vue";
import { MY_ORGANIZATION } from "@/store/modules.js";
import { GET_NEWS } from "@/store/action-types.js";
export default {
  name: "news-dashboard-card",
  props: {},
  components: { NewsListItems },
  computed: {
    news() {
      return this.$store.state.myOrganization.news;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MY_ORGANIZATION}${GET_NEWS}`, {
        organizationId: this.$route.params.organizationId,
        query: {
          onlyOwn: false,
          //   onlyOwn: true,
          //   ownUserGroup: this.$store.state.organization.membership.group.id,
        },
        paginationLimit: 3,
      });
    },
  },
};
</script>
